import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";



const MembersModal = ({ showSecond ,handleSecondClose ,memberDetail}) => {
  return (
    <Modal show={showSecond} onHide={handleSecondClose}>
    <Modal.Body>
      <div>
        <div className="team-member-detail">
          <div className="team-member-img">
            <img src={memberDetail?.image ? memberDetail?.image : require("../assets/images/vector-logo.svg").default} />
          </div>
          <h2>{memberDetail?.employeeName}</h2>
          <p>{memberDetail?.jobRole}</p>
          {memberDetail?.createdAt && 
          <p>Since {memberDetail?.createdAt ? moment(memberDetail?.createdAt).format('MMMM YYYY') : "N/A"} </p>}
        </div>
      </div>
    </Modal.Body>
  </Modal>
  )
}

export default MembersModal
